import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { apiService } from '../services/api';
import SEO from '../components/SEO';
import SafeImg from '../components/SafeImg';

const StaffPage = () => {
  const [staff, setStaff] = useState([]);

  useEffect(() => {
    apiService.staff.getAll()
      .then(res => {
        console.log('👨‍🏫 Fetched staff:', res.data);
        setStaff(res.data);
      })
      .catch((err) => {
        console.error('❌ Error fetching staff:', err);
        setStaff([
          { id: 1, name: 'Dr. Rajesh Kumar', designation: 'Director', department: 'Administration', qualification: 'Ph.D. in Education', experience: '25+ years', imageUrl: 'https://images.unsplash.com/photo-1556157382-97eda2d62296?w=400' },
          { id: 2, name: 'Mrs. Sunita Sharma', designation: 'Principal', department: 'Administration', qualification: 'M.Ed, M.A. English', experience: '20+ years', imageUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400' },
          { id: 3, name: 'Mr. Amit Verma', designation: 'Senior Mathematics Teacher', department: 'Mathematics', qualification: 'M.Sc. Mathematics', experience: '15+ years', imageUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400' },
          { id: 4, name: 'Ms. Priya Singh', designation: 'Science Teacher', department: 'Science', qualification: 'M.Sc. Physics', experience: '12+ years', imageUrl: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400' },
          { id: 5, name: 'Mr. Rakesh Gupta', designation: 'Sports Instructor', department: 'Physical Education', qualification: 'B.P.Ed', experience: '10+ years', imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400' },
          { id: 6, name: 'Mrs. Anjali Mehta', designation: 'Arts Teacher', department: 'Arts', qualification: 'M.F.A', experience: '8+ years', imageUrl: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400' }
        ]);
      });
  }, []);

  return (
    <>
      <SEO 
        title="Our Faculty & Teaching Staff | Vidya Vatika World School Panipat"
        description="Meet our qualified and experienced teaching staff dedicated to student success. Highly qualified faculty at Vidya Vatika World School."
        keywords="school teachers Panipat, qualified faculty, experienced educators, best teachers Haryana, CBSE school staff"
        canonicalUrl="/staff"
        ogImage="/images/og-image.jpg"
      />
      
      <div className="pt-20 min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold font-display mb-4">Our Faculty</h1>
          <p className="text-xl text-blue-100">Dedicated educators shaping futures</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {staff.map((member, index) => (
            <motion.div
              key={member.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all text-center"
            >
              <SafeImg
                key={(member.photoUrl || member.imageUrl || '') + member.id}
                src={member.photoUrl || member.imageUrl}
                alt={member.name}
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-blue-900 mb-1">{member.name}</h3>
                <p className="text-accent font-semibold mb-3">{member.designation || member.position}</p>
                <div className="text-sm text-gray-600 space-y-1">
                  <p><strong>Department:</strong> {member.department}</p>
                  <p><strong>Qualification:</strong> {member.qualification || member.qualifications}</p>
                  <p><strong>Experience:</strong> {member.experience || member.bio}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
};

export default StaffPage;
